export default __webpack_public_path__ + "static/media/tracking.5e034334.svg";